import UserChallengeEvent from './UserChallengeEvent';

export default UserChallengeEvent;
